import React, { useState, useRef, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';

import Fab from '@material-ui/core/Fab';
import Box from '@material-ui/core/Box';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import DeleteIcon from '@material-ui/icons/Delete';

import Tooltip from 'components/Tooltip';
import Dialog from 'components/RMSDialog';
import RMSXGrid from 'components/RMSXGrid';
import BackDatedRecordHistory from 'components/BackDatedRecordHistory';
import SOPFilter from 'components/RMSRecordsDialogs/Address/SOPFilter.js';
import PrintsSearch2 from 'components/RMSSearch/components/PrintsSearch2.js';
import QuickFilterSearch from 'components/RMSSearch/components/QuickFilterSearch';

import { handleError } from 'reducers/ErrorReducer';
import { getPeopleSops } from 'reducers/SearchReducer';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import { displayDateTime } from 'reducers/TimeReducer';
import { getFullPermissions } from 'reducers/PermissionsReducer.js';
import { savePeopleSOP, deletePeopleSOP } from 'reducers/PersonReducer';
import { closePeopleSOP, showPeopleSOP } from 'reducers/PersonDialogsReducer';

const useStyles = makeStyles((theme) => ({
  wrap: {
    padding: theme.spacing(3),
  },
  gridWrap: {
    width: '100%',
    boxSizing: 'border-box',
    height: 600,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
  fileInput: {
    display: 'none',
  },
  filterWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
}));
const bool = (params) => (params.value ? <CheckIcon /> : <span></span>);
// const showIcon = (params) => {
//   return <AttachmentIcon type={params.row.FileType} style={{ width: 24, height: 'auto' }} />;
// };
const defaultColumns = [
  {
    field: 'SOPID',
    headerName: 'Title',
    valueGetter: (params) => params.row.SOP.SOPID,
    width: 200,
    hide: false,
  },
  {
    field: 'DispatcherMessage',
    headerName: 'Dispatcher Message',
    valueGetter: (params) => params.row.SOP.DispatcherMessage,
    width: 150,
    hide: false,
  },
  {
    field: 'AlertMessage',
    headerName: 'Alert Message',
    valueGetter: (params) => params.row.SOP.AlertMessage,
    width: 150,
    hide: false,
  },
  {
    field: 'IsPagingMessageUsed',
    headerName: 'Is paging used',
    valueGetter: (params) => params.row.SOP.IsPagingMessageUsed,
    width: 150,
    hide: false,
  },
  {
    field: 'ShowPopupNotification',
    headerName: 'Popup Notification',
    valueGetter: (params) => params.row.SOP.ShowPopupNotification,
    width: 150,
    hide: false,
  },
  {
    field: 'Created',
    headerName: 'Created',
    width: 200,
    valueFormatter: (params) => displayDateTime(params.value),
    hide: false,
  },
  { field: 'CreatedBy', headerName: 'Created By', width: 150, hide: false },
  {
    field: 'Updated',
    headerName: 'Updated',
    width: 200,
    valueFormatter: (params) => displayDateTime(params.value),
    hide: false,
  },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 150, hide: false },
  { field: 'IsDeleted', headerName: 'Is Deleted', width: 150, hide: false },
  {
    field: 'Deleted',
    headerName: 'Deleted',
    width: 120,
    valueFormatter: (params) => displayDateTime(params.value),
    hide: false,
  },
  { field: 'DeletedBy', headerName: 'Deleted By', width: 150, hide: false },
  { field: 'DeletedIP', headerName: 'Deleted IP', width: 150, hide: false },
];

const Sops = (props) => {
  const classes = useStyles();
  const { personId, addPeopleSOP, onSOPChange } = props;
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selection, setSelection] = useState(null);
  const [tables, setTables] = useState(null);
  const [colsSeq, setColsSeq] = useState([]);
  const [columns, setColumns] = useState(defaultColumns);
  const dispatch = useDispatch();
  const mountedRef = useRef(true);
  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedSOP, setSelectedSOP] = useState(null);

  const [recordHistoryData, setRecordHistoryData] = useState({
    shouldVisible: true,
    isDisabled: true,
    createUpdateInfo: {},
  });
  const [showRecordHistory, setShowRecordHistory] = useState(false);

  const perms = getFullPermissions('globals', 'People', 'any');
  const canEditPerson = perms.Edit;
  useEffect(() => {
    personId && getData();
  }, []);

  const getData = async () => {
    try {
      const data = await getPeopleSops(personId);
      if (!mountedRef.current) return;
      setRows(processData(data.data));
      setLoaded(true);
      onSOPChange?.(data.data.length);
    } catch (err) {
      console.log(err);
      props.handleError(err, 'Error receiving person sops data.');
    }
  };

  const processData = (data) => {
    return data.map((row, idx) => {
      return {
        ...row,
        id: idx,
      };
    });
  };

  const handleCloseRecordHistoryDialog = () => setShowRecordHistory(false);

  const add = () => {
    setRecordHistoryData({
      shouldVisible: true,
      isDisabled: true,
      createUpdateInfo: {},
    });

    dispatch(showPeopleSOP({ ptsPersonId: personId }));
  };

  const close = () => {
    dispatch(closePeopleSOP());
  };

  const save = async () => {
    dispatch(showSpinner());
    if (addPeopleSOP.SOP) {
      const sopExists = rows.find((row) => row.ptsSOPID === selectedSOP);
      if (!sopExists) {
        await deletePeopleSOP({
          ptsParentID: addPeopleSOP.ptsParentID,
          ParentType: 'Person',
          ptsSOPID: addPeopleSOP.ptsSOPID,
        });
      }
    }
    await savePeopleSOP({
      ptsParentID: personId,
      ParentType: 'Person',
      ptsSOPID: selectedSOP,
    })
      .then(() => {
        close();
        getData();
        dispatch(hideSpinner());
      })
      .catch(() => {
        close();
        getData();
        dispatch(hideSpinner());
      });
  };

  const deleteSOP = async () => {
    const item = rows.find((row) => row.id === selection);

    const updatedData = rows.filter((row) => row.id !== selection);
    setRows(updatedData);
    onSOPChange?.(rows.length);

    if (item) {
      dispatch(showSpinner());
      await deletePeopleSOP({
        ptsParentID: personId,
        ParentType: 'Person',
        ptsSOPID: item.ptsSOPID,
      })
        .then(() => {
          getData();
          dispatch(hideSpinner());
        })
        .catch((err) => {
          console.log(err);
          getData();
          dispatch(hideSpinner());
        });
    }
  };

  const formContent = () => {
    return (
      <SOPFilter selectSOP={setSelectedSOP} sopValue={addPeopleSOP.SOP ? addPeopleSOP.SOP : null} />
    );
  };

  const renderActions = () => {
    return (
      <>
        {recordHistoryData?.shouldVisible && (
          <Box className="">
            <BackDatedRecordHistory
              showRecordHistory={showRecordHistory}
              setShowRecordHistory={setShowRecordHistory}
              disabled={recordHistoryData?.isDisabled}
              handleCloseRecordHistoryDialog={handleCloseRecordHistoryDialog}
              createUpdateInfo={recordHistoryData?.createUpdateInfo}></BackDatedRecordHistory>
          </Box>
        )}
        <Button color="primary" variant="contained" autoFocus onClick={save}>
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  const edit = () => {
    const item = rows.find((row) => row.id === selection);

    setRecordHistoryData({
      shouldVisible: true,
      isDisabled: !item.Created,
      createUpdateInfo: {
        created: item.Created,
        createdBy: item.CreatedBy,
        updated: item.Updated,
        updatedBy: item.UpdatedBy,
      },
    });

    dispatch(showPeopleSOP(item));
  };

  const renderActionsSops = () => (
    <div className={classes.actions}>
      <Tooltip title="Print">
        <PrintsSearch2 title="SOPS" data={filteredRows} cols={columns} />
      </Tooltip>
      <Tooltip title="Add SOP">
        <Fab size="small" color="secondary" disabled={!canEditPerson} onClick={add}>
          <AddIcon />
        </Fab>
      </Tooltip>

      {selection !== null && (
        <>
          <Tooltip title="Edit Feature">
            <Fab size="small" color="secondary" disabled={!canEditPerson} onClick={edit}>
              <EditIcon />
            </Fab>
          </Tooltip>
          <Tooltip title="Delete SOP">
            <Fab size="small" color="secondary" disabled={!canEditPerson} onClick={deleteSOP}>
              <DeleteIcon />
            </Fab>
          </Tooltip>
        </>
      )}
    </div>
  );

  return (
    <div className={classes.wrap}>
      <div className={classes.filterWrap}>
        <div className={classes.filterWrap}>
          <QuickFilterSearch
            rows={rows}
            columns={columns}
            setFilteredRows={setFilteredRows}
            style={{ marginTop: 0, paddingBottom: 14 }}
          />
          {renderActionsSops()}
        </div>
      </div>

      {addPeopleSOP && (
        <Dialog
          toolbar
          onClose={close}
          title={addPeopleSOP.SOP ? 'Edit SOP' : 'Add SOP'}
          actions={renderActions()}>
          {formContent()}
        </Dialog>
      )}

      <RMSXGrid
        name="personSops"
        columns={columns}
        setColumns={setColumns}
        rows={filteredRows}
        loading={!loaded}
        setSelection={setSelection}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    addPeopleSOP: state.dialogs.addPeopleSOP,
  };
};
export default connect(mapStateToProps, { handleError, showSpinner, hideSpinner })(Sops);
